/**
 * Map relevant information from a mergeList response
 * @param {*} mergeListResponse the http response object (quite complicated object)
 */
export function parseMerges(mergeListResponse) {
  const result = []

  if (mergeListResponse && mergeListResponse instanceof Array && mergeListResponse.length > 0) {
    mergeListResponse.forEach(merge => {
      const parsedMerge = {}
      parsedMerge.averageFilePath = merge.averageFilePath
      parsedMerge.creationDate = merge.creationDate
      parsedMerge.discardedFrameNameList = merge.discardedFrameNameList
      parsedMerge.framesCount = merge.framesCount
      parsedMerge.framesMerge = merge.framesMerge
      parsedMerge.measurementId = merge.measurementId
      parsedMerge.mergeId = merge.mergeId

      const frameList = merge.framelist3VO
      if (frameList) {
        const parsedFrameList = {}
        parsedMerge.frameList = parsedFrameList
        parsedFrameList.comments = frameList.comments
        parsedFrameList.frames = []

        const frames = frameList.frametolist3VOs
        if (frames && frames instanceof Array && frames.length > 0) {
          frames.forEach(frame => {
            if (frame.frame3VO) {
              const parsedFrame = {}
              parsedFrame.filePath = frame.frame3VO.filePath
              parsedFrame.frameId = frame.frame3VO.frameId
              parsedFrame.comments = frame.frame3VO.comments
              parsedFrame.creationDate = frame.frame3VO.creationDate

              parsedFrameList.frames.push(parsedFrame)
            }
          })
        }
      }
      result.push(parsedMerge)
    })
    return result
  }
  return null
}
